import styled from 'styled-components';
import { useSelector } from 'react-redux';
import AnnouncementSkeleton from '../../components/ui/organisms/subject/announcements/AnnouncementSkeleton';
import NotFoundImg from '../../assets/media/aden/not_found.png';
import Pagination from '../../components/ui/organisms/subject/announcements/Pagination';
import useLayout from '../../hooks/useLayout';
import PopUpSuccess from '../../components/ui/organisms/subject/announcements/PopUpSuccess';
import ModalCreateAnnouncement from '../../components/ui/organisms/subject/announcements/ModalCreateAnnouncement';
import { announcementSchema } from '../../utils/schemas';
import AnnouncementsGrid from '../../components/ui/organisms/subject/announcements/AnnouncementsGrid';
import useGeneralSubjectAnnouncements from '../../hooks/subject/useGeneralSubjectAnnouncements';
import useSubjectAnnouncements from '../../hooks/subject/useSubjectAnnouncements';
import ErrorResponse from '../../components/common/ErrorResponse';

const GeneralAnnouncements = (props) => {
    const { professor } = props;

    // //REDUX
    const repo_id = useSelector((state) => state.auth.user.repo_id);
    const activeRol = useSelector((state) => state.auth.activeRol);
    const { setMenu } = useLayout();

    const {
        announcementsGeneralData,
        loading,
        error,
        page,
        setPage,
        pageMax,
        resetGeneralData
    } = useGeneralSubjectAnnouncements(repo_id, activeRol);

    let assigment_id = 0;

    const {
        handleSubmitAnnouncementEdited,
        handleAnnouncementUnpublishing,
        openEditModal,
        setOpenEditModal,
        openModalSuccess,
        setOpenModalSuccess,
        succesAction,
        setErrorAction,
        errorAction,
        loadingAction,
    } = useSubjectAnnouncements(assigment_id, activeRol, repo_id);

   
    //RETURN
    if (error) {
        return (
            <Wrapper>
                <ErrorResponse message="No se pudo acceder a la información de anuncios, intenta nuevamente en unos minutos" />
            </Wrapper>
        );
    }

    if (loading) {
        return (
            <Wrapper>
                <AnnouncementSkeleton />
            </Wrapper>
        );
    }

    if (
        announcementsGeneralData.length === 0 ||
        announcementsGeneralData === undefined
    ) {
        return (
            <WrapperNotFound>
                <img src={NotFoundImg} alt="not-found" />
                <p>
                    Aún no tienes anuncios en <br /> tu bandeja de entrada.
                </p>
            </WrapperNotFound>
        );
    }
    return (
        <Wrapper>
            <>
                <AnnouncementsTitle>
                    Anuncios generales por asignaturas:
                </AnnouncementsTitle>
                <AnnouncementsGrid
                    initialValues={announcementsGeneralData}
                    setOpenEditModal={setOpenEditModal}
                    rol={activeRol}
                    loading={loading}
                />
                <Pagination page={page} setPage={setPage} pageMax={pageMax} />
            </>
            {/* Edición de anuncio para rol docente*/}
            {openEditModal && (
                <ModalCreateAnnouncement
                    initialValues={openEditModal}
                    handleSubmitAnnouncementEdited={
                        handleSubmitAnnouncementEdited
                    }
                    handleAnnouncementUnpublishing={
                        handleAnnouncementUnpublishing
                    }
                    announcementSchema={announcementSchema}
                    setOpenModal={setOpenEditModal}
                    loading={loadingAction}
                    error={errorAction}
                    type="edit"
                    setErrorAction={setErrorAction}
                />
            )}
            {openModalSuccess && !!succesAction && (
                <PopUpSuccess
                    setOpenModal={setOpenModalSuccess}
                    actionSucces={succesAction}
                    resetData={resetGeneralData}
                />
            )}
        </Wrapper>
    );
};

export default GeneralAnnouncements;

const Wrapper = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;

    h1 {
        color: #616161;
        font-size: 20px;
        font-weight: 500;
    }
`;

const WrapperNotFound = styled.div`
    position: relative;
    background-color: #fff;
    width: 100%;
    height: 80vh;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    p {
        font-size: 24px;
        font-weight: 700;
        color: #b31d15;
        text-align: center;
    }
`;

const AnnouncementsTitle = styled.h1`
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    color: #616161;
`;
